import React, {useEffect, useState} from "react";
import Button from "../../components/v2/Button";
import StepperCar from "../../components/v2/StepperCar";
import Input from "../../components/v2/Input";
import useValetStore from "./hooks/useValetStore";
import Swal from "sweetalert2";
import {ValetSteps} from "./constants/ValetSteps";
import RadioSelector from "../../components/v2/RadioSelector";
import {Link} from "react-router-dom";
import IconCarValidated from "../../assets/v2/badge-check.png";
import {useTranslation} from "react-i18next";

export default function ValetYourVehicle({
                                             backClickedHandler
                                         }) {

    const {
        callPost,
        callGet,
        userData,
        setVehicleData,
        setStep,
        isStandAlone
    } = useValetStore();

    const [brand, setBrand] = useState(userData?.vehicle?.brand ?? '');
    const [model, setModel] = useState(userData?.vehicle?.model ?? '');
    const [plate, setPlate] = useState(userData?.vehicle?.licence_plate ?? '');

    const [vehicleId, setVehicleId] = useState(userData?.vehicle?.vehicle?.id);
    const [vehicleList, setVehicleList] = useState(null);

    const formRef = React.useRef();

    useEffect(() => {
        if (vehicleList == null) {
            return;
        }
        if (vehicleList.length > 0 && vehicleId == null) {
            setVehicleId(vehicleList[0].id);
        }
    }, [vehicleList]);


    useEffect(() => {
        getVehicleList();
    }, []);

    const {t} = useTranslation('common');

    const getVehicleList = () => {
        callGet('vehicle_index', (resultData => {
            setVehicleList(resultData.vehicles);
        }));
    }

    // Est-ce qu'on affiche le formulaire de saisi d'un véhicule ?
    const showForm = () => {
        // console.log("showForm", vehicleList.length, vehicleId);
        if (vehicleList.length == 0) {
            return true;
        }
        if (vehicleId == -1) {
            return true;
        }
        return false;
    }

    const showList = () => {
        return vehicleList.length > 0;
    }

    const showManageButton = () => {
        return vehicleList.length > 0 && !isStandAlone;
    }

    const nextClickedHandler = (e) => {
        if (showForm()) {
            if (!formRef.current.reportValidity()) {
                return;
            }
            callPost('vehicle_register_quick', {
                'brand': brand, 'model': model, 'licence_plate': plate, 'vehicle_id': vehicleId == -1 ? null : vehicleId
            }, (data) => {
                setVehicleData({
                    brand: brand,
                    model: model,
                    licence_plate: plate,
                    vehicle: {id: data.vehicle_id},
                })
                gotoNextStep();
            }, (failResultData) => {
                Swal.fire({
                    text: failResultData.message, icon: 'error',
                });
            });
        } else {
            let vehicle = vehicleList.find((vehicle) => vehicle.id == vehicleId);

            // console.log("vehicle", vehicle);

            setVehicleData({
                brand: vehicle.brand,
                model: vehicle.model,
                licence_plate: vehicle.licence_plate,
                vehicle: {id: vehicleId}
            })
            gotoNextStep();
        }
    }

    const gotoNextStep = () => {
        if (isStandAlone) {
            setStep(ValetSteps.YOUR_IDENTITY);
        } else {
            setStep(ValetSteps.YOUR_ORDER)
        }
    }

    const getSelectorList = () => {
        let list = vehicleList.slice();
        list = list.map((vehicle) => {
            return {
                value: vehicle.id,
                label: <div className="flex">
                    <div>{vehicle.brand} {vehicle.model} [{vehicle.licence_plate}]</div>
                    {vehicle.car_category_id != null ?
                        <img src={IconCarValidated} className="w-[24px] h-[24px] ml-2"/> : null}
                </div>
            }
        })
        if (list.length > 0) {
            list.push({
                value: -1,
                label: t('valet.vehicle.text')
            });
        }
        return list;
    }

    const vehicleSelectedHandler = (vehicleId) => {
        setVehicleId(vehicleId);
    }

    // Ca charge..
    if (vehicleList == null) return null;

    return <div className="h-full flex flex-col p-4 gap-4">
        <StepperCar value={50}/>
        <div className="text-white text-[30px] font-bold">
            {t('valet.vehicle.text2')}
        </div>

        {/* TODO : Utiliser le nouveau composant VehicleSelector, ptet pas si simple avec le nouveau véhicule*/}

        {showList() ? <>
            <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl">
                <legend className="text-sm">&nbsp;{t('valet.vehicle.text3')}&nbsp;</legend>
                <RadioSelector id="vehicle"
                               version={"list"}
                               value={vehicleId}
                               values={getSelectorList()}
                               onChange={vehicleSelectedHandler}/>
            </fieldset>
        </> : null}

        {showForm() ? <>
            <form ref={formRef}>
                <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl mt-4">
                    <legend className="text-sm">&nbsp;{t('valet.vehicle.text4')}&nbsp;</legend>
                    <Input id="brand" label={t('valet.vehicle.text5')} placeholder={t('valet.vehicle.text6')}
                           value={brand}
                           required={true}
                           onChange={(e) => setBrand(e)}
                    />
                    <Input id="model" label={t('valet.vehicle.text7')} placeholder={t('valet.vehicle.text8')}
                           value={model}
                           required={true}
                           onChange={(e) => setModel(e)}
                    />
                    <Input id="plate" label={t('valet.vehicle.text9')} placeholder={t('valet.vehicle.text10')}
                           value={plate}
                           required={true}
                           onChange={(e) => setPlate(e)}
                    />
                </fieldset>
            </form>
        </> : null}
        {showManageButton() ?
            <Link to={"/vehicle"} className="text-white text-sm underline"><Button
                outline={true}
                text={t('valet.vehicle.text11')}
                subtext={t('valet.vehicle.text12')}/></Link> : null}
        <div className="grow">
        </div>
        <div className="flex gap-4">
            <Button outline text={<div>
                <div>{t('valet.vehicle.text13')}</div>
                <div className="text-sm mt-[-8px]">{t('valet.vehicle.text14')}</div>
            </div>} clickHandler={backClickedHandler}/>
            <Button text={t('valet.vehicle.text15')} clickHandler={nextClickedHandler}/>
        </div>
    </div>
}